module.exports = __webpack_public_path__ + "static/media/3XL.f1bf9e73.jpg";